// Credits: https://stackoverflow.com/questions/8279859/get-first-letter-of-each-word-in-a-string-in-javascript
export default (name: string) =>
  name
    .split(' ')
    .map(element => element.charAt(0))
    .slice(0, 2)
    .join('')
    .toUpperCase();
